// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/main.scss
// module id = 1268
// module chunks = 0